import group from '@tk/utilities/tk.array.group';
import { fetchRequest } from '@tk/utilities/tk.fetch';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';

interface ArtSpecRow {
    unit: string;
    groupId: number;
    groupName: string;
    label: string;
    value: string;
}

interface ArtSpecData {
    data: ArtSpecRow[];
}

export default class TCArtSpecTable extends TKArtSpecTable {
    articleId?: string;

    constructor() {
        super();

        this.articleId = this.getAttribute('data-tk-id') || undefined;
    }

    fetch(id = this.articleId) {
        fetchRequest({
            requestURL: this.url!,
            resolveHandler: this.refreshContent.bind(this),
            payload: { id },
        });
    }

    refreshContent(response: TKResponse<ArtSpecData>) {
        if (!response || !response.success) return;
        const { data } = response.dataAsJson;
        const groupedList = Object.values(group(data, 'groupId'));
        const groups = groupedList.map((rows) => ({
            groupName: rows.at(0)?.groupName,
            rows: rows
                .filter((row) => row.value !== '')
                .map((row) => ({
                    label: row.label,
                    value: row.value,
                    unit: row.unit,
                })),
        }));
        if (!this.listWrapper) return;
        this.listWrapper.innerHTML = '';
        groups.forEach((group) => {
            if (group.rows.length === 0) return;
            const groupElement = (this.groupTemplateElement!.content.cloneNode(true) as HTMLElement).children[0];
            const groupTitleElement = groupElement.querySelector('[data-tk-title]');
            if (!groupTitleElement) return;
            groupTitleElement.textContent = group.groupName || '';

            group.rows.forEach((row) => {
                const rowElement = (this.rowTemplateElement!.content.cloneNode(true) as HTMLElement).children[0];
                const labelElement = rowElement.querySelector('[data-tk-label]');
                if (!labelElement) return;
                const valueElement = rowElement.querySelector('[data-tk-value]');
                if (!valueElement) return;
                const unitElement = rowElement.querySelector('[data-tk-unit]');
                if (!unitElement) return;
                labelElement.textContent = row.label;
                if (row.value.match(this.colorHexRegex)) {
                    valueElement.insertAdjacentElement(
                        'beforeend',
                        this.createColorElement(row.value),
                    );
                } else {
                    valueElement.textContent = row.value;
                    unitElement.textContent = row.unit;
                }
                groupElement.insertAdjacentElement('beforeend', rowElement);
            });

            this.listWrapper!.insertAdjacentElement('beforeend', groupElement);
        });

        this.innerHTML = '';
        this.insertAdjacentElement('beforeend', this.listWrapper!);

        this.classList.add(this.loadedClassName);
        const showMoreComponent = this.closest<HTMLElement>('tk-show-more');
        showMoreComponent && showMoreComponent.dispatchEvent(new Event('tk-show-more-recalc'));
    }
}
